import moment from 'moment';

export const getFirstDayOfNextMonth = () => {
    const nextMonth = moment().add(1, 'months');
    return nextMonth.startOf('month');
};